var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "delivery-tab-layout" },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "delivery-tab-layout__loader" },
            [_c("ui-loader", { attrs: { size: "60" } })],
            1
          )
        : [
            _c(
              "div",
              { staticClass: "delivery-tab-layout__content" },
              [_vm._t("default")],
              2
            ),
            _c(
              "div",
              { staticClass: "delivery-tab-layout__aside" },
              [_vm._t("aside")],
              2
            )
          ],
      _vm._t("append")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }